import React from 'react'
import { Typography, Stack, Button } from '@mui/material';

import BodyPartImage from '../assets/icons/body-part.png';
import TargerImage from '../assets/icons/target.png';
import EquipmentImage from '../assets/icons/equipment.png';


const Detail = ( {exerciseDetail} ) => {
    const { bodyPart, gifUrl, name, target, equipment } = exerciseDetail;

    const extraDetail = [
        {
            icon: BodyPartImage,
            name: bodyPart,
        },
        {
            icon: TargerImage,
            name: target,
        },
        {
            icon: EquipmentImage,
            name: equipment,
        },
    ]

  return (
    <Stack  gap="80px" sx={{flexDirection: {lg:'row'}, p:'20px', alignItems:"center"}}>
        <img src={gifUrl} alt={name} loading='lazy ' className='detail-image' />
        <Stack sx={{ gap: { lg: '35px', xs:'20px'}}}>
            <Typography variant='h4' textTransform='capitalize' sx={{marginTop: {lg: '120px', xs:'0'}}}>
                {name} 
            </Typography>
            <Typography variant='h6'>
                Exercises keep you strong and healthy. {name} {` `}
                is one of the best exercises to target your {target}. It will help you to improve your mood and gain energy.
            </Typography>
            {extraDetail.map((item) =>(
                <Stack key={item.name} direction='row' gap='24px' alignItems='center'>
                    <Button sx={{ background:'#fff2db', borderRadius:'50%', width:'70px', height:'70px'}}>
                        <img src={item.icon} alt={bodyPart} style={{width: '35px', height:'35px'}} />
                    </Button>
                    <Typography variant='h5' textTransform='capitalize'>
                        {item.name}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    </Stack>
  )
}

export default Detail